/**
@flow
@format
*/

const ModalConstants = {
  modalPadding: 32, // top or bottom
  titlePaddingBottom: 32,
  titleHeight: 30, // 30 + 32
  cropperButtonGroup: 130, // height
  cropperButtonGroupMargin: 32,
  editCropMargin: 46,
};

export default ModalConstants;
